import React, { useEffect, useRef, useState } from 'react';
import { useField } from '@unform/core';
import { WithContext as ReactTags, Tag } from 'react-tag-input';
import { Typography } from '../..';

interface Props {
    name: string;
    label?: string;
};

type ArrayTextInputProps = JSX.IntrinsicElements['input'] & Props;

const ArrayTextInput: React.FC<ArrayTextInputProps> = (
  {
    name, label, type, ...rest
  }: ArrayTextInputProps,
) => {
  const inputRef = useRef<any>(null);
  const {
    fieldName, defaultValue, registerField, error,
  } = useField(name);
  const [tags, setTags] = useState<Tag[]>(() => {
    if (defaultValue && Array.isArray(defaultValue)) {
      return defaultValue.map((item, index) => ({
        id: String(index),
        className: '',
        text: typeof item === 'string' ? item : item.text || item.displayValue
      }));
    }
    return [];
  });

  const handleDelete = (i: number) => {
    setTags(tags.filter((tag, index) => index !== i));
  };

  const handleAddition = (tag: Tag) => {
    setTags([...tags, { ...tag, className: tag.className || '' }]);
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue() {
        const t = tags.map((item) => item.text || item.id);
        return t;
      },
    });
  }, [defaultValue, fieldName, registerField, tags]);

  return (
    <>
      {label
      && (
      <Typography variant="title">
        {' '}
        {label}
      </Typography>
      )}
      <ReactTags
        tags={tags}
        placeholder="Digite o nome da Tag e aperte enter."
        handleDelete={handleDelete}
        handleAddition={handleAddition}
        delimiters={[188, 13]}
        classNames={{
          tags: 'ReactTags__tags',
          tagInput: 'ReactTags__tagInput',
          tagInputField: 'ReactTags__tagInputField',
          selected: 'ReactTags__selected',
          tag: 'ReactTags__tag',
          remove: 'ReactTags__remove',
          suggestions: 'ReactTags__suggestions',
          activeSuggestion: 'ReactTags__activeSuggestion'
        }}
      />
      {error
        && (
        <Typography color="#f44336" margin="-15px 0 0 0" size="0.75rem" variant="text">
          {error}
        </Typography>
        )}
    </>
  );
};

export { ArrayTextInput };
